import React from 'react';
import DataGrid from 'shared/grids/DataGrid';
import { getFavouritesOrders } from 'src/fetch/orders';
import { Link } from 'react-router-dom';

const FavouritesOrdersGrid = () => {
  const getData = (params) => getFavouritesOrders(params);

  return (
    <DataGrid
      name='favourite-orders'
      getData={getData}
      hasRecycleBin={false}
      hasUnifiedTextSearch={false}
      hideActionsCell
      hasExport={false}
      columns={[
        {
          field: 'proNumber',
          title: 'Pro Number',
          cell: ({ dataItem }) => <td><Link to={`/orders/orders/${dataItem.proNumber}`} target='_blank'>{dataItem.proNumber}</Link></td>,
        },
        {
          field: 'customerName',
          title: 'Customer',
        },
        {
          field: 'billToName',
          title: 'Bill To',
        },
      ]}

    />
  );
};

export default FavouritesOrdersGrid;